import Globals from "../utils/globalUtils";
import React, { useEffect, useState } from "react";

const uploadVideo = (access, formData) => {
  return Globals.sendRequest({
    url: "/api/livestream/record/",
    method: "POST",
    headers: {
      Authorization: `Bearer ${access}`,
    },
    data: formData,
  });
};

const updateVideo = (access, formData) => {
  return Globals.sendRequest({
    url: `/api/livestream/record/`,
    method: "PATCH",
    headers: {
      Authorization: `Bearer ${access}`,
    },
    data: formData,
  });
};

const deleteVideo = (access, channelID, recordingID) => {
  return Globals.sendRequest({
    url: `/api/livestream/record/?channel_id=${channelID}&recording_id=${recordingID}`,
    method: "DELETE",
    Authorization: `Bearer ${access}`, // ${TOKEN_VALUE}
  });
};

const createPlaylist = (access, formData) => {
  return Globals.sendRequest({
    url: `/api/livestream/playlist/`,
    method: "POST",
    Authorization: `Bearer ${access}`, // ${TOKEN_VALUE}
    data: formData
  });
};

const updatePlaylist = (access, formData) => {
  return Globals.sendRequest({
    url: `/api/livestream/playlist/`,
    method: "PATCH",
    Authorization: `Bearer ${access}`, // ${TOKEN_VALUE}
    data: formData
  });
};

const deletePlaylist = (access, channelID, playlistID) => {
  return Globals.sendRequest({
    url: `/api/livestream/record/?channel_id=${channelID}&playlist_id=${playlistID}`,
    method: "DELETE",
    Authorization: `Bearer ${access}`, // ${TOKEN_VALUE}
  });
};

const getVideos = (access, channelID, recordingID) => {
  if(recordingID){
    return Globals.sendRequest({
      url: `/api/livestream/record/?q=${channelID}&recording_id=${recordingID}`,
      method: "GET",
      Authorization: `Bearer ${access}`, // ${TOKEN_VALUE}
    });
  } else{
    return Globals.sendRequest({
      url: `/api/livestream/record/?q=${channelID}`,
      method: "GET",
      Authorization: `Bearer ${access}`, // ${TOKEN_VALUE}
    });
  }
}

const getPlaylists = (access, channelID, playlistID) => {
  if (playlistID) {
    return Globals.sendRequest({
      url: `/api/livestream/playlist/?q=${channelID}&playlist_id=${playlistID}`,
      method: "GET",
      Authorization: `Bearer ${access}`, // ${TOKEN_VALUE}
    });
  } else {
    return Globals.sendRequest({
      url: `/api/livestream/playlist/?q=${channelID}`,
      method: "GET",
      Authorization: `Bearer ${access}`, // ${TOKEN_VALUE}
    });
  }
};

const PlaylistService = {
  uploadVideo,
  updateVideo,
  deleteVideo,
  createPlaylist,
  updatePlaylist,
  deletePlaylist,
  getVideos,
  getPlaylists,
};

export default PlaylistService;
